import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { GolfCourse } from "@material-ui/icons";
import { PayStatus } from "../../types/player";
import EmptyPositionRow from "./EmptyPositionRow";
import { PositionsInfo } from "./IndividualLeaderBoard";
import PlayerName from "components/SharedComponents/PlayerName";
import PaymentStatusBadge from "components/SharedComponents/PaymentStatusBadge";
import { getHandicapDisplay } from "utils";

interface Props {
  player: any;
  activeUserId: string;
  info: PositionsInfo;
  isStroke: boolean;
  isPaidGame: boolean;
  isFinalScore: boolean;
  isStandardGame: boolean;
  exactHandicaps: boolean;
  shouldPayBeforePlay: boolean;
  openScoreCardDialog(player: any): void;
  verified?: boolean;
  trRefs: React.RefObject<HTMLTableRowElement[]>;
  isOrganizer: boolean;
  widescreen: boolean;
  index: number;
  handicapAdjustment: boolean;
}

export default function LeaderboardPlayerRow(props: Props) {
  const {
    player,
    isStroke,
    activeUserId,
    isPaidGame,
    isFinalScore,
    isStandardGame,
    exactHandicaps,
    verified,
    isOrganizer,
    widescreen,
  } = props;
  const { showInfo, position, showInTwoSteps } = props.info;

  const isUnpaid = isPaidGame && player.payStatus === PayStatus.NOT_PAID;
  const empty = !showInfo && !isOrganizer && !isUnpaid;

  if (empty) {
    return <EmptyPositionRow trRefs={props.trRefs} index={props.index} cells={isStroke ? 6 : 7} position={position} />;
  }

  return (
    <TableRow
      onClick={() => (showInfo || isOrganizer ? props.openScoreCardDialog(player) : null)}
      style={{
        ...(player._id === activeUserId ? { background: "#cce8cf" } : {}),
        ...(!showInfo && isOrganizer ? { opacity: 0.5 } : {}),
      }}
      key={player._id}
      ref={el => props.trRefs.current && el && (props.trRefs.current[props.index] = el)}
    >
      <TableCell align="center">
        <span style={{ display: "flex", justifyContent: "space-between" }}>
          {position}

          {verified !== undefined ? <span style={{ color: verified ? "green" : "orange" }}>&#86;</span> : null}
        </span>
      </TableCell>
      {showInTwoSteps ? (
        <>
          <TableCell align="center" />
          <TableCell align="center" />
          <TableCell align="center" />
          {isStandardGame && <TableCell align="center" />}
        </>
      ) : (
        <>
          <TableCell align="left" style={{ width: 28, paddingLeft: 8, paddingRight: 4 }}>
            <GolfCourse color={"primary"} style={{ fontSize: 18, verticalAlign: "middle", display: "block" }} />
          </TableCell>
          <TableCell align="left" style={{ paddingLeft: 4 }}>
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "100%",
                gap: 4,
              }}
            >
              <PlayerName
                lighter={!showInfo && isOrganizer && !widescreen}
                isGuest={player.guest}
                name={player.name}
                lastName={player.lastName}
              />
              {isPaidGame ? (
                <span
                  style={{
                    flexShrink: 0,
                    width: widescreen ? 32 : 18,
                    display: "inline-flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <PaymentStatusBadge payStatus={player.payStatus} size={widescreen ? "presentation" : "compact"} />
                </span>
              ) : null}
            </span>
          </TableCell>
          <TableCell align="center">{`${exactHandicaps ? getHandicapDisplay(player.hcp) : getHandicapDisplay(player.hcp)}`}</TableCell>
          {isStandardGame && <TableCell align="center">{player.hci ? getHandicapDisplay(player.hci) : "0"}</TableCell>}
        </>
      )}
      {player.disqualified ? (
        <TableCell colSpan={4} align="center">
          DQ
        </TableCell>
      ) : (
        <>
          <TableCell align="center">{player.gross}</TableCell>
          <TableCell align="center">{player.nett}</TableCell>
          {!isStroke && <TableCell align="center">{player.pts}</TableCell>}

          {isFinalScore && !props.handicapAdjustment ? null : (
            <TableCell align="center">
              {isFinalScore
                ? getHandicapDisplay(Number(player.newhcp))
                : player.thru && (
                    <>
                      {player.thru}
                      <sup>{player.startingHole}</sup>
                    </>
                  )}
            </TableCell>
          )}
        </>
      )}
    </TableRow>
  );
}
